import { inject, Injectable } from "@angular/core";
import { CommonsAlertHandlingService } from "@jack-sparrow-libraries/angular-business-commons";
import { UiKitToasterService } from "@jack-sparrow-libraries/ui-kit";

@Injectable({ providedIn: "root" })
export class ToasterService implements CommonsAlertHandlingService {
	private readonly toastrSrv = inject(UiKitToasterService);

	handleError(titre: string, description: string): void {
		this.toastrSrv.show({
			color: "alert",
			titre: titre,
			subtitle: description,
			progressBar: true,
		});
	}

	handleSuccess(titre: string, description: string): void {
		this.toastrSrv.show({
			color: "valid",
			titre: titre,
			subtitle: description,
			progressBar: true,
		});
	}
}
